import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaNovaVerzijaComponent, PwaOfflineComponent } from './shared/pwa';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, PwaNovaVerzijaComponent, PwaOfflineComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <router-outlet />
    <app-pwa-nova-verzija />
    <app-pwa-offline />
  `,
})
export class App {}
